import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HomeService } from '../../home/home.service';
import { Observable } from 'rxjs';
import { resturlConstants } from '../../../rest-url/resturlconstants';
import { environment } from '../../../environments/environment';

@Injectable()
export class CurrentDepositsService {

  constructor(private http: HttpClient, private homeService: HomeService) { }

  getCurrentSummary(): Observable<any> {

    return this.http.post<any>(resturlConstants.currentUrl,
      {
        'userId': localStorage.getItem('userId'),
        'clientShortCode': environment.clientShortCode
      },
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', this.homeService.getAuthHeader())
      });

  }
}
